// Ciudades principales de Colombia con los municipios de su área de influencia, para que las zonas de entrega se escojan de una lista
// y no queden escritas de varias maneras («pereira», «Pereira », «Dosquebradas Rda»…). El nombre guardado es siempre el de esta lista.

export const COLOMBIA_AREAS = [
  { city: 'Medellín', department: 'Antioquia', municipios: ['Bello', 'Envigado', 'Itagüí', 'Sabaneta', 'La Estrella', 'Caldas', 'Copacabana', 'Girardota', 'Barbosa'] },
  { city: 'Rionegro', department: 'Antioquia', municipios: ['La Ceja', 'Marinilla', 'El Retiro', 'Guarne', 'El Carmen de Viboral'] },
  { city: 'Apartadó', department: 'Antioquia', municipios: ['Carepa', 'Chigorodó', 'Turbo'] },
  { city: 'Barranquilla', department: 'Atlántico', municipios: ['Soledad', 'Malambo', 'Galapa', 'Puerto Colombia', 'Sabanalarga'] },
  { city: 'Bogotá', department: 'Bogotá D.C.', municipios: ['Soacha', 'Chía', 'Cajicá', 'Zipaquirá', 'Mosquera', 'Funza', 'Madrid', 'Facatativá', 'Sopó', 'Tocancipá', 'La Calera', 'Cota', 'Tenjo', 'Gachancipá'] },
  { city: 'Girardot', department: 'Cundinamarca', municipios: ['Flandes', 'Ricaurte'] },
  { city: 'Fusagasugá', department: 'Cundinamarca', municipios: [] },
  { city: 'Cartagena', department: 'Bolívar', municipios: ['Turbaco', 'Arjona', 'Santa Rosa de Lima'] },
  { city: 'Magangué', department: 'Bolívar', municipios: [] },
  { city: 'Tunja', department: 'Boyacá', municipios: ['Paipa', 'Motavita', 'Samacá'] },
  { city: 'Duitama', department: 'Boyacá', municipios: [] },
  { city: 'Sogamoso', department: 'Boyacá', municipios: ['Nobsa', 'Tibasosa'] },
  { city: 'Manizales', department: 'Caldas', municipios: ['Villamaría', 'Chinchiná', 'Neira', 'Palestina'] },
  { city: 'Florencia', department: 'Caquetá', municipios: [] },
  { city: 'Yopal', department: 'Casanare', municipios: [] },
  { city: 'Popayán', department: 'Cauca', municipios: [] },
  { city: 'Valledupar', department: 'Cesar', municipios: [] },
  { city: 'Aguachica', department: 'Cesar', municipios: [] },
  { city: 'Quibdó', department: 'Chocó', municipios: [] },
  { city: 'Montería', department: 'Córdoba', municipios: ['Cereté', 'Lorica', 'Sahagún', 'Planeta Rica'] },
  { city: 'Neiva', department: 'Huila', municipios: ['Rivera', 'Campoalegre'] },
  { city: 'Pitalito', department: 'Huila', municipios: [] },
  { city: 'Riohacha', department: 'La Guajira', municipios: [] },
  { city: 'Maicao', department: 'La Guajira', municipios: [] },
  { city: 'Santa Marta', department: 'Magdalena', municipios: ['Ciénaga'] },
  { city: 'Villavicencio', department: 'Meta', municipios: ['Acacías', 'Restrepo', 'Cumaral', 'Puerto López'] },
  { city: 'Pasto', department: 'Nariño', municipios: [] },
  { city: 'Ipiales', department: 'Nariño', municipios: [] },
  { city: 'Tumaco', department: 'Nariño', municipios: [] },
  { city: 'Cúcuta', department: 'Norte de Santander', municipios: ['Villa del Rosario', 'Los Patios', 'El Zulia'] },
  { city: 'Ocaña', department: 'Norte de Santander', municipios: [] },
  { city: 'Armenia', department: 'Quindío', municipios: ['Calarcá', 'La Tebaida', 'Montenegro', 'Circasia', 'Quimbaya', 'Salento'] },
  { city: 'Pereira', department: 'Risaralda', municipios: ['Dosquebradas', 'La Virginia', 'Santa Rosa de Cabal', 'Marsella'] },
  { city: 'Bucaramanga', department: 'Santander', municipios: ['Floridablanca', 'Girón', 'Piedecuesta'] },
  { city: 'Barrancabermeja', department: 'Santander', municipios: [] },
  { city: 'San Gil', department: 'Santander', municipios: [] },
  { city: 'Sincelejo', department: 'Sucre', municipios: [] },
  { city: 'Ibagué', department: 'Tolima', municipios: ['Espinal', 'Melgar'] },
  { city: 'Cali', department: 'Valle del Cauca', municipios: ['Yumbo', 'Palmira', 'Jamundí', 'Candelaria'] },
  { city: 'Buenaventura', department: 'Valle del Cauca', municipios: [] },
  { city: 'Tuluá', department: 'Valle del Cauca', municipios: [] },
  { city: 'Cartago', department: 'Valle del Cauca', municipios: [] },
  { city: 'Buga', department: 'Valle del Cauca', municipios: [] },
  { city: 'Arauca', department: 'Arauca', municipios: [] },
  { city: 'Leticia', department: 'Amazonas', municipios: [] },
  { city: 'San Andrés', department: 'San Andrés y Providencia', municipios: [] }
];

const fold = (v) => String(v ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/\b(d\.?\s?c\.?|distrito capital)\b/g, ' ').replace(/[^a-z0-9]+/g, ' ').trim();

// Todos los lugares con su departamento y, si es un municipio, la ciudad principal de su área.
export const COLOMBIA_PLACES = COLOMBIA_AREAS.flatMap((a) => [
  { name: a.city, department: a.department, area: null },
  ...a.municipios.map((m) => ({ name: m, department: a.department, area: a.city }))
]);

const BY_KEY = new Map();
COLOMBIA_PLACES.forEach((p) => { if (!BY_KEY.has(fold(p.name))) BY_KEY.set(fold(p.name), p); });

// «pereira », «PEREIRA», «Bogota D.C.» → el nombre de la lista. Si no está en la lista, queda con mayúscula inicial en cada palabra.
export const canonicalCity = (text) => {
  const clean = String(text ?? '').trim().replace(/\s+/g, ' ');
  if (!clean) return '';
  const hit = BY_KEY.get(fold(clean));
  if (hit) return hit.name;
  return clean.toLowerCase().replace(/(^|\s)(\p{L})/gu, (_, sp, ch) => sp + ch.toUpperCase());
};

export const inCatalog = (text) => BY_KEY.has(fold(text));

// Quita repetidos y variantes de una lista de zonas, respetando el orden.
export const canonicalList = (list) => {
  const seen = new Set();
  return (Array.isArray(list) ? list : []).map(canonicalCity).filter((c) => c && !seen.has(fold(c)) && seen.add(fold(c)));
};

export const searchPlaces = (query, limit = 8) => {
  const q = fold(query);
  if (!q) return [];
  return COLOMBIA_PLACES.filter((p) => fold(p.name).includes(q) || fold(p.department).includes(q))
    .sort((a, b) => (fold(a.name).startsWith(q) ? 0 : 1) - (fold(b.name).startsWith(q) ? 0 : 1) || (a.area ? 1 : 0) - (b.area ? 1 : 0))
    .slice(0, limit);
};

// Una ciudad principal y todos los municipios de su área.
export const areaOf = (city) => {
  const a = COLOMBIA_AREAS.find((x) => fold(x.city) === fold(city));
  return a ? [a.city, ...a.municipios] : [];
};

// Ciudades de reparto de un domiciliario: una o varias, guardadas en `staff.ciudad` separadas por «|» (una sola ciudad se guarda igual que antes).
// Acepta una lista o un texto separado por «|» o coma; devuelve nombres únicos y sin variantes.
export const parseStaffCities = (value) => canonicalList(Array.isArray(value) ? value : String(value ?? '').split(/[|,]/));
export const joinStaffCities = (value) => parseStaffCities(value).join('|');
export const formatStaffCities = (value) => parseStaffCities(value).join(', ');
